export default __webpack_public_path__ + "static/media/my-needs-icon-active.bf617722.svg";